<template>
  <div v-loading="is_analysis_loading_state" style="display: flex; flex-direction: row; justify-content: center; height: 100%; width: 100%; align-items: stretch">
    <!-- 外层容器：全屏居中 + 科技感背景 -->
    <div style="position: relative" class="topic-assistant-container" :class="{ big_chat_box: showWorkBench === false, small_chat_box: showWorkBench === true }">
      <!-- 工具选择 -->
      <span class="tool_label" @click="close_tool()"
        ><!-- change_tool(null)是关闭工具 -->
        <i class="el-icon-back tool_close_icon"></i>
        文献翻译
      </span>

      <div class="core-card">
        <!-- 问候语组件 -->
        <!-- <GreetingLabel :greetingMsg="greetingMsg" :curInfoToolTipMsg="curInfoToolTipMsg"/> -->
        <GreetingLabel ref="childRefGreetingLabel" />

        <div style="display: flex; flex-direction: row; justify-content: center">
          <el-upload
            class="upload-demo"
            drag
            :action="globalUrl.file_upload"
            :headers="uploadHeaders"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :multiple="false"
            :on-exceed="handleExceed"
            :on-success="handleUploadSuccess"
            :file-list="fileList"
            :accept="accept_file_list.join(',')"
            :disabled="is_analysis_loading_state"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text" v-safe-html="is_analysis_loading_state ? analysis_loading_msg : upload_intro_msg"></div>
            <div class="el-upload__tip" slot="tip">PS: 请上传 10M 以内的 PDF 文件</div>
          </el-upload>
        </div>

        <!-- 文献分析板块 -->
        <el-row class="tool_intro_box">
          <div v-show="analysis_case_list.length > 0" style="font-size: 13px; border-bottom: 1px solid var(--bg-front); color: var(--txt-color3) !important">文献翻译示例</div>
          <template v-for="(analysis_case, idx) in analysis_case_list">
            <el-button :key="idx" class="tool_intro_btn" icon="el-icon-document" round @click="full_txt_art_analysis(analysis_case['file_ruid'], analysis_case['file_name'], false)">{{ analysis_case["file_name"] }}</el-button>
          </template>
        </el-row>

        <el-row class="tool_intro_box">
          <div v-show="upload_recent_list.length > 0" style="font-size: 13px; border-bottom: 1px solid var(--bg-front); color: var(--txt-color3) !important">最近上传</div>
          <template v-for="(upload_recent, idx) in upload_recent_list">
            <el-button :key="idx" class="tool_intro_btn" icon="el-icon-document" round @click="full_txt_art_analysis(upload_recent['file_ruid'], upload_recent['file_name'], false)">{{ upload_recent["file_name"] }}</el-button>
          </template>
        </el-row>
      </div>
    </div>

    <!-- 工作台 -->
    <!-- <div v-if="showWorkBench" class="my_workbench">
      <FullTxtArtAnalysisResultWorkBench :full_txt_art_analysis_data="full_txt_art_analysis_data" @clossPaperAnalysis="clossWorkBench" style="width: 100%; height: 100%;"/>
    </div> -->
  </div>
</template>

<script>
/* eslint-disable */
import GreetingLabel from "./GreetingLabel.vue";
// import WorkBench from '../components/WorkBench.vue';
// import FullTxtArtAnalysisResultWorkBench from './FullTxtArtAnalysisResultWorkBench.vue'
export default {
  name: "PdfTranslate",
  components: {
    GreetingLabel,
    // WorkBench,
    // FullTxtArtAnalysisResultWorkBench,
  },
  props: {
    greetingMsg: {},
    curInfoToolTipMsg: {
      type: String,
    },
    dataContent: {
      type: Array,
    },
  },
  watch: {
    // 发送按钮高亮/置灰控制
    dataContent(newVal, oldVal) {
      // 有传入的数据就渲染数据
      if (newVal != null) {
        this.full_txt_art_analysis_data = this.dataContent;
        this.showWorkBench = true;
      }
    },
  },
  data() {
    return {
      full_txt_art_analysis_data: null,
      // form: {
      //   researchInterest: '',
      //   tutorDirection: '',
      // },
      // formRules: {
      //   researchInterest: [
      //     { required: true, message: '请输入研究兴趣', trigger: 'blur' },
      //     { min: 10, message: '研究兴趣描述至少10个字符', trigger: 'blur' }
      //   ]
      // },
      // isLoading: false,
      showWorkBench: false,
      workbench_content: null,
      // assistance_case_list: [],

      // 上传文件数组
      fileList: [],
      // 文件类型控制数组
      // accept_file_list: ['.*'],
      // accept_file_list: ['.pdf', '.jpg', '.jpeg', '.png'],
      accept_file_list: [".pdf"],
      // 最大文件上传数
      max_file_num: 1,
      // 最近上传记录
      upload_recent_list: [],
      // token
      uploadHeaders: this.get_token(),
      // 论文分析小栗子
      analysis_case_list: [],

      // 分析状态
      is_analysis_loading_state: false,

      // 上传提示信息
      upload_intro_msg: "将文件拖到此处，或<em>点击上传</em>",
      analysis_loading_msg: "论文分析中，请稍后...",
    };
  },
  mounted() {
    // 渲染功能10字简介
    this.$refs.childRefGreetingLabel.render_greeting_msg(this.greetingMsg, this.curInfoToolTipMsg);

    // // 请求小栗子
    // this.select_topic_assistance_case()

    // 获取最近上传记录
    this.get_recent_upload();
    // 获取示例
    this.get_analysis_case();
  },
  watch: {
    // 发送按钮高亮/置灰控制
    dataContent(newVal, oldVal) {
      // 有传入的数据就渲染数据
      if (newVal != null) {
        this.full_txt_art_analysis_data = this.dataContent;
        this.showWorkBench = true;
      }
    },
  },
  methods: {
    close_tool() {
      this.$emit("close_tool");
    },
    get_token() {
      let token = localStorage.getItem("token");
      if (token != null) {
        return {
          Authorization: token, // 常用的 Token 格式（Bearer + 空格 + Token）
          // 其他自定义头（如果需要）：
          // 'Content-Type': 'multipart/form-data',
          // 'X-Token': token
        };
      }
    },
    // 获取论文全文分析结果并渲染
    full_txt_art_analysis(data_ruid, file_name, is_create_task) {
      // alert(file_name)
      // 展示文献分析页
      // this.full_txt_art_analysis_data = null
      // setTimeout(() => {
      //   this.analysis_table_show_state = true
      // }, 150);
      this.is_analysis_loading_state = true; // 开始转圈

      this.$http
        .get(this.globalUrl.full_txt_art_analysis, { params: { data_ruid: data_ruid, file_name: file_name, is_create_task: is_create_task } })
        .then(res => {
          // this.upload_recent_list = res.data
          // console.log(res.data)
          this.full_txt_art_analysis_data = res.data;
          this.showWorkBench = true;

          // // 数据生成点击事件（后续点击按钮回显）
          // let [render_res, work_bench_data_idx, work_bench_data, data_list] = this_.render_data_show_btn(message.type, message.content)
          // this_.bot_answer += render_res
          // // 记录学术检索的参考文献，后面要往答案上渲染悬浮按钮
          // if(message.type=='reference' && data_list.length>0) reference = data_list
          // // 数据传递给工作台（立即回显，分词检索立即回显，学术检索不直接回显）
          // if(message.type=='word_segment_search_res') this_.$emit('renderWorkbenchData', work_bench_data, work_bench_data_idx)
        })
        .finally(() => {
          // 无论成功/失败，最终都会执行这里
          this.is_analysis_loading_state = false; // 结束转圈
          this.analysis_table_show_state = true; // 打开渲染结果
        });
    },
    // 获取最近上传记录
    get_recent_upload() {
      this.$http.get(this.globalUrl.full_txt_art_analysis_recent).then(res => {
        // console.log(res.data)
        this.upload_recent_list = res.data;
      });
    },
    get_analysis_case() {
      this.$http.get(this.globalUrl.full_txt_art_analysis_case).then(res => {
        // console.log(res.data)
        this.analysis_case_list = res.data;
      });
    },
    // // 请求小栗子
    // select_topic_assistance_case() {
    //   this.$http.get(this.globalUrl.select_topic_assistance_case).then(res => {
    //     this.assistance_case_list = res.data
    //   })
    // },

    // 关闭工作台
    clossWorkBench() {
      this.showWorkBench = false;
    },
    // generation_func(researchInterest, tutorDirection, is_create_task) {
    //   this.isLoading = true;
    //   this.showWorkBench = false
    //   this.workbench_content = null
    //   this.$message({
    //       message: '选题方案生成中，请稍后...',
    //       type: 'success',
    //       duration: 1500,
    //       center: true
    //     });

    //   this.$http.post(this.globalUrl.topic_assistance, {user_interest: researchInterest, teacher_direction: tutorDirection, is_create_task: is_create_task}).then(res => {
    //     console.log(res.data)
    //     this.workbench_content = res.data
    //     this.showWorkBench = true
    //   }).finally(() => {
    //     // 无论成功/失败，最终都会执行这里
    //     this.isLoading = false
    //   })
    // },
    // toGenerate(researchInterest, tutorDirection, is_case) {

    //   if(is_case) this.generation_func(researchInterest, tutorDirection, false) // 命中了示例的回答本身也不会创建任务，所以这里传false还是true都行
    //   else {
    //     this.$refs.topicForm.validate((isValid) => {
    //       if (isValid) {
    //         this.generation_func(researchInterest, tutorDirection, true)
    //       } else {
    //         this.$message({
    //           message: '请完善研究兴趣信息（至少10个字符）',
    //           type: 'error',
    //           duration: 1500,
    //           center: true
    //         });
    //       }
    //     });
    //   }
    // }
    // 上传部分相关方法 ----------------------------------------------------------------------------------------------------------------
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePreview(file) {
      // console.log(file);
    },
    handleExceed(file, fileList) {
      // console.log(file, fileList);
      // alert(122)
    },
    beforeRemove(file, fileList) {
      // return this.$confirm(`确定移除 ${ file.name }？`);
    },
    // 新增：上传成功处理
    handleUploadSuccess(res, files, fileList) {
      // alert(11)
      // if(this.cur_tool_idx && ['pdf_translation', 'full_txt_art_analysis'].indexOf(this.tool_list[this.cur_tool_idx]['function'])!=-1) {
      //   let file_list = fileList.slice(1, fileList.length)  // 去掉第一个，加上最新的，数组长度为1时也就是替换文件
      //   file_list.push(files[0])
      //   console.log(file_list)
      //   this.fileList = file_list
      // } else this.$message.warning(`当前最大支持上传 ${this.max_file_num} 个文件`);
      // console.log('文件上传成功：', response, file, fileList);
      // // 在这里执行上传完成后的操作，例如：
      // // 1. 提示上传成功
      // this.$message.success(`${file.name} 上传成功`);
      // // 2. 刷新文件列表/更新数据
      // this.fileList = fileList;
      // // 3. 调用其他业务接口（如解析文件、同步数据）
      // // this.analyzeFile(response.fileId);

      // 文献分析
      if (res.code == -1) {
        this.$message.warning(res.msg);
        return;
      }

      this.fileList = [fileList[fileList.length - 1]]; // 上传成功会自动加一条，这时候我们只留最新的
      // if(this.fileList.length> 0) {
      //   let file_list = fileList.slice(1, fileList.length)  // 去掉第一个，加上最新的，数组长度为1时也就是替换文件
      //   // file_list.push(files[0])
      //   // console.log(file_list)
      //   this.fileList = file_list
      // }
      let data_ruid = res.data;
      this.full_txt_art_analysis(data_ruid, files.name, true);
    },
    // --------------------------------------------------------------------------------------------------------------------------------
  },
};
</script>

<!-- 适配全局样式变量的科技风样式 + 固定800px不变形 -->
<style scoped>
/* 其他原有样式不变，新增以下样式 */

/* 上传区域小loading样式 */
.upload-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.upload-loading i {
  font-size: 20px;
  color: var(--blue); /* 使用全局主色调 */
  animation: el-icon-loading 1.5s linear infinite;
}

/* 按钮loading样式优化（保持ElementUI风格，微调大小） */
:deep(.tool_intro_btn .el-icon-loading) {
  font-size: 14px !important;
  margin-right: 5px !important;
}

/* 上传组件禁用状态样式 */
:deep(.upload-demo.is-disabled) {
  opacity: 0.7;
  cursor: not-allowed;
}

.upload-demo {
  width: 458px;
}
.my_workbench {
  overflow-y: auto;
  overflow-x: hidden;
  /* 适配 Firefox */
  scrollbar-width: none;
  /* 适配 IE/Edge 旧版 */
  -ms-overflow-style: none;
  /* 必须保留 overflow 保证滚动功能（根据需求选 auto/scroll/y/x） */
}
/* 适配 Chrome/Safari/Edge 新版（webkit 内核） */
.my_workbench::-webkit-scrollbar {
  display: none; /* 完全隐藏滚动条 */
}
.my_workbench::-webkit-scrollbar:vertical {
  display: none;
}
.my_workbench::-webkit-scrollbar:horizontal {
  display: none;
}

/* 核心固定尺寸变量 */
:root {
  --fixed-width: 800px; /* 核心固定宽度 */
  --form-label-width: 110px; /* 表单标签宽度 */
  --radius-sm: 8px; /* 小圆角 */
  --radius-md: 12px; /* 中圆角 */
  --transition: all 0.3s ease; /* 过渡动画 */
}

/* 外层容器：全屏居中 + 适配全局背景 */
.topic-assistant-container {
  /* height: 100vh; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: background-color 0.3s ease;
}

/* 核心卡片：固定800px + 适配全局卡片样式 */
.core-card {
  margin: 0 20px;
  width: var(--fixed-width);
  max-width: 100%;
  /* padding: 45px 0; */
  box-sizing: border-box;
  position: relative;
  overflow-y: auto;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

/* 表单样式：清晰层级 + 网格化 */
.topic-form {
  width: 100%;
}

.form-item {
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
}

/* 表单标签：左对齐 + 适配全局文字颜色 */
.el-form-item__label {
  width: var(--form-label-width) !important;
  font-size: var(--font-size);
  color: var(--txt-color);
  font-weight: 500;
  padding: 0 0 10px 0 !important;
  text-align: left !important;
}

/* 表单控件容器：自适应宽度 */
.el-form-item__content {
  flex: 1;
  width: calc(100% - var(--form-label-width)) !important;
}

/* 自定义表单控件：输入框/文本域 */
.form-control {
  width: 100%;
  border: none;
  border-radius: var(--radius-sm);
  transition: var(--transition);
  box-sizing: border-box;
}

.form-control::v-deep .el-textarea__inner {
  padding: 16px 18px;
  font-size: var(--font-size);
  color: var(--txt-color);
  border: 1px solid var(--btn-border);
  border-radius: var(--radius-sm);
  line-height: var(--line-height-base);
  resize: none;
  background-color: var(--bg-front);
  transition: color 0.3s ease;
  border-radius: 20px !important;
}

/* 隐藏 Webkit 内核浏览器（Chrome、Safari、Edge）的滚动条 */
.form-control::v-deep .el-textarea__inner::-webkit-scrollbar {
  display: none; /* 直接隐藏滚动条 */
}

/* 隐藏 Firefox 浏览器的滚动条 */
.form-control::v-deep .el-textarea__inner {
  scrollbar-width: none; /* Firefox 专属属性，隐藏滚动条 */
}

/* 隐藏 IE/旧版 Edge 浏览器的滚动条（兼容性补充） */
.form-control::v-deep .el-textarea__inner {
  -ms-overflow-style: none; /* IE/Edge 专属属性 */
}

/* 输入框聚焦效果：适配全局主色 + 轻微发光 */
.form-control:focus-within {
  border-color: var(--blue);
  /* box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1); */
  outline: none;
}

/* 表单提示文本：小字号 + 适配全局文字颜色 */
.form-hint {
  font-size: 13px;
  color: var(--txt-color2);
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: color 0.3s ease;
}

.form-hint i {
  font-size: 13px;
  color: var(--blue);
}

.optional-hint {
  color: var(--txt-color3);
}

/* 提交按钮区域：居中 */
.submit-item {
  margin-top: 15px;
  text-align: center;
}

/* 生成按钮：调整为柔和色调，适配全局变量，降低亮度 */
.generate-btn {
  /* 使用全局柔和蓝色，降低背景色饱和度 */
  background-color: var(--btn-bg-hover2) !important;
  /* border: 1px solid var(--blue) !important; */
  border-radius: 20px !important;
  padding: 12px 50px !important;
  font-size: var(--font-size);
  font-weight: 500;
  color: #ffffff !important;
  transition: var(--transition);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  /* 增加轻微透明，降低亮度 */
  opacity: 0.95;
  /* 柔和阴影代替高亮 */
  box-shadow: 0 2px 8px rgba(6, 64, 126, 0.2) !important;
}

.generate-btn:hover {
  /* 夜间模式用深蓝，白天模式用稍深的蓝 */
  background-color: var(--btn-bg-hover2) !important;
  border-color: var(--btn-bg-hover2) !important;
  transform: translateY(-2px);
  /* 弱化hover阴影，减少刺眼感 */
  box-shadow: 0 4px 12px rgba(6, 64, 126, 0.25) !important;
  opacity: 1;
}

.generate-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(6, 64, 126, 0.2) !important;
}

.generate-btn.is-loading {
  /* loading状态更柔和的透明度 */
  background-color: var(--btn-bg-hover2) !important;
  border-color: var(--blue) !important;
  opacity: 0.85 !important;
  transform: none !important;
  box-shadow: 0 2px 8px rgba(6, 64, 126, 0.2) !important;
}

/* 响应式：500-800px区间强制固定800px，不变形 */
@media (min-width: 500px) and (max-width: 800px) {
  .topic-assistant-container {
    padding: 30px 0;
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .topic-assistant-container::-webkit-scrollbar {
    display: none;
  }
  .core-card {
    width: var(--fixed-width); /* 强制固定800px */
  }
}

/* 小于500px兼容：自适应布局 */
@media (max-width: 500px) {
  .core-card {
    padding: 35px 25px;
  }
  .el-form-item__label {
    width: 100% !important;
  }
  .el-form-item__content {
    width: 100% !important;
  }
  .generate-btn {
    width: 100%;
    justify-content: center;
    padding: 12px 0 !important;
  }
}

/* 深度选择器：适配ElementUI组件样式 */
:deep(.el-textarea__inner::placeholder) {
  color: var(--place-holder-color) !important;
  font-size: var(--font-size);
}

:deep(.el-message) {
  border-radius: var(--radius-sm);
  background-color: var(--bg-front);
  border: 1px solid var(--label-border);
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

:deep(.el-message__content) {
  font-size: var(--font-size);
  color: var(--txt-color);
  transition: color 0.3s ease;
}

:deep(.el-message-success) {
  color: var(--green);
}

:deep(.el-message-error) {
  color: var(--red);
}

/* 隐藏 Webkit 内核浏览器（Chrome、Safari、Edge）的滚动条 */
.core-card::-webkit-scrollbar {
  display: none; /* 直接隐藏滚动条 */
}

/* 隐藏 Firefox 浏览器的滚动条 */
.core-card {
  scrollbar-width: none; /* Firefox 专属属性，隐藏滚动条 */
}

/* 隐藏 IE/旧版 Edge 浏览器的滚动条（兼容性补充） */
.core-card {
  -ms-overflow-style: none; /* IE/Edge 专属属性 */
}

.big_chat_box {
  width: 800px;
}

.small_chat_box {
  width: 500px;
  min-width: 500px;
}

/* ----------------------------------- 示例按钮的相关样式 ------------------------------------------- */
/* 容器：控制宽度500-800px，居中缩进，继承全局背景 */
.assistance-case-container {
  width: clamp(500px, 100%-20px, 780px);
  margin: 0 auto;
  padding: 10px;
  background-color: transparent; /* 继承父元素背景 */
}

/* 案例按钮样式：完全使用全局CSS变量，覆盖Element默认样式 */
.assistance-case-btn {
  width: 100% !important;
  margin: 5px 0 !important;
  text-align: left !important;
  line-height: var(--line-height-base) !important; /* 继承全局行高 */
  padding: 12px 23px !important; /* 与全局按钮padding一致 */
  border-radius: 20px !important; /* 与全局按钮圆角一致 */
  background-color: var(--btn-bg) !important; /* 全局按钮背景 */
  border: 1px solid var(--btn-border) !important; /* 全局按钮边框 */
  color: var(--btn-color) !important; /* 全局按钮文字色 */
  white-space: normal !important; /* 强制取消单行限制 */
  word-wrap: break-word !important; /* 基础换行 */
  transition: all 0.3s ease !important; /* 继承全局过渡动画 */
}

/* 按钮hover效果：使用全局hover变量 */
.assistance-case-btn:hover {
  background-color: var(--btn-bg-hover) !important; /* 全局按钮hover背景 */
  border-color: var(--btn-border-hover) !important; /* 全局按钮hover边框 */
  color: var(--btn-color-hover) !important; /* 全局按钮hover文字色 */
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1) !important; /* 弱阴影，不破坏全局风格 */
  transform: translateY(-1px) !important; /* 轻微上浮，增强交互 */
}

/* 内容容器：间距适配全局风格 */
.case-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px; /* 紧凑间距，符合全局UI风格 */
}

/* 单个条目：flex布局，标签+内容 */
.case-item {
  display: flex;
  flex-wrap: wrap; /* 标签和内容超出时换行 */
  width: 100%;
  align-items: flex-start; /* 顶部对齐，避免文本换行后错位 */
}

/* 标签样式：使用全局文字色2，加粗突出 */
.case-label {
  font-weight: 600;
  color: var(--txt-color2); /* 全局次要文字色 */
  min-width: 80px; /* 固定标签宽度，保证对齐 */
  flex-shrink: 0; /* 禁止标签收缩 */
  font-size: var(--font-size); /* 继承全局字体大小 */
}

/* 内容值样式：核心换行逻辑，使用全局主文字色 */
.case-value {
  color: var(--txt-color); /* 全局主文字色 */
  flex: 1; /* 占满剩余宽度 */
  word-break: break-all; /* 强制换行：连续字母/数字 */
  white-space: pre-wrap; /* 保留原文本换行符 */
  word-wrap: break-word; /* 中英文混合换行 */
  font-size: var(--font-size); /* 继承全局字体大小 */
  line-height: var(--line-height-base); /* 继承全局行高 */
}

/* 适配小屏幕：标签宽度自适应 */
@media (max-width: 600px) {
  .case-label {
    min-width: 60px;
  }
}
.tool_intro_box {
  margin: 15px 0;
  /* height: 80px; */
}

.tool_label {
  position: absolute;
  align-self: flex-start;
  padding: 5px 30px;
  left: -20px;
  top: 0px;
  /* border-radius: 10px; */
  border-end-end-radius: 20px;
  border-end-start-radius: 20px;
  background-color: var(--bg-front);
  z-index: 999;
  color: var(--btn-color-hover);
  cursor: pointer;
  /* 右下淡阴影（#00000026 = 黑色 + 15%不透明度） */
  box-shadow: 3px 3px 8px var(--shadow-color);
}

.tool_intro_btn {
  margin: 5px;
  margin-left: 0 !important;
  max-width: 320px; /* 最大宽度450px */
  min-width: 110px;
  white-space: nowrap; /* 强制文本单行显示 */
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
}
</style>
